import { combineReducers } from 'redux';

import ids from './ids';
import isLoading from './isLoading';
import page from './page';

export default combineReducers({
  isLoading,
  page,
  ids,
});
